<template>
  <v-dialog v-model="value" persistent :max-width="maxWidth+'px'">
    <material-card color="primary" :title="title" :text="item.name">
      <v-form ref="form" v-model="validForm">
        <v-container :style="'max-width:'+maxWidth+'px'">
          <v-layout wrap>

            <v-flex xs12 sm9 md9 v-if="isFirst">
              <v-select
                md4
                clearable
                v-model="item.qualitychecker_id"
                :items="qualityCheckers"
                color="primary"
                hide-no-data
                item-text="surname"
                item-value="id"
                label="Quality Checker"
                placehoder="Choose Quality Checker"
                :rules="[v => !!v || 'Quality checker is required']"
              >
                <template slot="item" slot-scope="{ item }">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.surname }} {{ item.name }}</v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </v-select>
            </v-flex>

            <!-- //issue 679 -->    
            <v-flex xs12 sm3 md3 v-if="!isFirst && isQualityChecker && isTurnOfQC">
              <v-select
              clearable
                label="Status"
                v-model="item.status"
                :items="[ ( (isReply || isOpen) ? 'Reply' : 'Open' ), 'Closed']"
                :rules="[v => !!v || 'Status is required']"
              ></v-select>
            </v-flex>
            <!-- //issue 679 -->    

            <v-flex xs12 sm3 md3 v-if="isFirst || (isTurnOfQC && item.status == 'Closed')">
              <v-textarea
                label="Comment"
                v-model="item.comment"
              ></v-textarea>
            </v-flex>

            <!-- //issue 679 -->    
            <v-flex xs12 sm3 md3 v-if="!isFirst && isQualityChecker && isTurnOfQC && (item.status == 'Open' || item.status == 'Reply')">
              <v-textarea
                label="Non conformity"
                v-model="item.non_conformity"
                :rules="[v => !!v || 'Non conformity is required']"
              ></v-textarea>
            </v-flex>
            <!-- //issue 679 -->    
         
            


            <!-- //issue 679 -->    
            <v-flex xs12 sm3 md3 v-if="!isFirst && !isQualityChecker && !isTurnOfQC && (isOpen || isReply)">
              <v-textarea
                label="Action Taken"
                v-model="item.action_taken"
                :rules="[v => !!v || 'Action taken is required']"
              ></v-textarea>
            </v-flex>
            <!-- //issue 679 -->    
                     

            <!-- //issue 679 -->    
            <v-flex xs12 sm1 md1 v-if="((!isQualityChecker && !isTurnOfQC) || (isQualityChecker && isTurnOfQC)) && (isReply || isOpen || isFirst)">

                <v-tooltip top :disabled="!validForm">
                  <template slot="activator" slot-scope="{ on }">

                    <v-btn
                      class="mx-1 font-weight-light"
                      color="purple"
                      small
                      :disabled="!validForm"
                      @click="save()">
                      Save
                    </v-btn>

                  </template>
                  <span>Add</span>
                </v-tooltip>

            </v-flex>
            <!-- //issue 679 -->    

          </v-layout>
        </v-container>
      </v-form>

      <v-divider></v-divider>

      <v-data-table v-if="!isFirst"
        :items="qualityChecks"
        hide-actions
        :headers="[
          { text: 'Quality checker', value: 'qualitychecker.name', sortable: false },
          { text: 'Non conformity', value: 'non_conformity', sortable: false },
          { text: 'Action taken', value: 'action_taken', sortable: false },
          { text: 'status', value: 'status', sortable: false },
          { text: 'Insert at', value: 'insert_at', sortable: false },
          { text: 'Insert by', value: 'insert_by', sortable: false }
        ]"
      >
      <template slot="items" slot-scope="{ item }" >
        <td>
          
          <a flat @click="remove(item)" v-if="isSecond && !isQualityChecker">
            <v-icon color="primary">mdi-delete-forever</v-icon>
          </a>

          {{ item.qualitychecker.name }} {{ item.qualitychecker.surname }} </td>
        <td>{{ item.non_conformity }} </td>
        <td>{{ item.action_taken }}</td>
        <td>{{ item.status }}</td>
        <!-- //issue 679 -->    
        <td>{{ formatDate(item.insert_at) }}</td>    
        <!-- //issue 679 -->    
        <td>{{ item.insertby.name }} {{ item.insertby.surname }}</td>       
      </template>
    </v-data-table>


 
      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { getList, upsert, remove } from "@/api/base_api";
import { getNextQualityChecker } from "@/api/qualitycheck";
import validators from "@/utils/validators";
//issue 679
import moment from 'moment';
//issue 679

export default {
  inheritAttrs: false,
  props: {
    value: Boolean,
    itemEvent: Object,
    eventType: String
  },
  data() {
    return {
      validForm: true,
      validators,
      item: {},
      qualityChecks: [],
      qualityCheckers: []
    };
  },
  mounted() {
    
  },
  watch: {
    value(v) {
      if (v) {        
        this.item.eventId = this.itemEvent.id
        this.item.eventType = this.eventType
        // this.item.adverse_event_id = this.itemEvent.id;
        this.item.insertby_id = this.currentUserId;
        this.$refs.form.reset();     
        this.getData();   
      } else {
        // this.$refs.form.reset(); 
      }
    }
  },
  computed: {
    maxWidth() {
      return this.isFirst ? 500 : 1560
    },
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      return "Quality Check for Event (" + this.itemEvent.cin + ")";
    },
    isFirst() {
      return this.qualityChecks.length == 0
    },
    isSecond() {
      return this.qualityChecks.length == 1
    },
    isQualityChecker() {
      return this.qualityChecker.id == this.currentUserId
    },
    currentUserId() {
      return this.$store.getters.userObj.account_id
    },
    isTurnOfQC() {
      return this.qualityChecks.length && 
        this.qualityChecks[this.qualityChecks.length-1].insertby_id != this.qualityChecks[this.qualityChecks.length-1].qualitychecker_id
    },
    qualityChecker() {
      return this.qualityChecks.length ? this.qualityChecks[0].qualitychecker : {}
    },
    isOpen() {
      return this.qualityChecks.length && 
        this.qualityChecks[this.qualityChecks.length-1].status == 'Open'
    },
    //issue 679
    isReply() {
      return this.qualityChecks.length && 
        this.qualityChecks[this.qualityChecks.length-1].status == 'Reply'
    },
    //issue 679
    idField() {
      return this.eventType + '_id'
    }
  },
  methods: {
    //issue 679
    formatDate(x)
    {
      return moment(new Date(x)).format('DD-MMM-YYYY HH:mm:ss') 
    }
    ,
    //issue 679
    getData() {
     // this.item.qualitychecker_id = null

      if(this.isFirst) {

        getList('account', {quality_check: true, id: "!=" + this.currentUserId,status:"Active"}, {rowsPerPage:-1}).then( data => {
          this.qualityCheckers = data.data;
          getNextQualityChecker({currentUserId: this.currentUserId, eventId:this.itemEvent.id, eventType: this.eventType}).then( data2 => {
            this.item.qualitychecker_id = data2.id;
          });
        });
        
      }

      const filter = {}
      filter[this.idField] = this.itemEvent.id
      getList('qualitycheck', filter, {rowsPerPage:-1}).then( data => {
        this.qualityChecks = data.data;
      });
      
    },
    close() {
      this.$emit("input", false);
    },
    save() {
      console.log("quality check",this.item)
      

      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }

      if(!this.isFirst) {
        this.item.qualitychecker_id = this.qualityChecker.id
      }
      if(this.item.status == 'Closed') {
        this.itemEvent.quality_check = 1
        this.itemEvent.quality_check_date = new Date().toLocaleDateString();
      }

      if(this.isFirst) {
        this.item.isFirst = true
      }

      //issue 679
      this.itemEvent.qualitychecklastrow = "Reply "
    //issue 679
      if (!this.item.status) {this.item.status = 'Reply'}
      if(this.isFirst) {
        this.itemEvent.qualitychecklastrow = "Open "
        this.item.status = 'Open'
      }
      if(this.item.status == 'Closed') {
        this.itemEvent.qualitychecklastrow = "Closed "
        this.item.status = 'Closed'
      }
      //issue 679
      if (this.item.non_conformity)
      {
        this.itemEvent.qualitychecklastrow += " , Not Conformity : " + this.item.non_conformity
      }
      if (this.item.action_taken)
      {
        this.itemEvent.qualitychecklastrow += " , Action taken : " + this.item.action_taken
      }
      //issue 679
      //if (!this.item.status)
      //{
      //  this.item.status = 'Open'
      //}
      //issue 679
      //issue 679


      upsert('qualitycheck', this.item)
        .then(data => {
          this.$store.dispatch("app/openSnackbar", {
            message: "Quality check updated correctly",
            color: "success"
          });
          this.getData();
          this.item = {};
          this.item.eventId = this.itemEvent.id
          this.item.eventType = this.eventType
          this.item.insertby_id = this.currentUserId; 
        })
        .catch(e => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the Quality check update. " +
              e.response.data.message,
            color: "error"
          });
        });
    },
    remove(item) {
      remove('qualitycheck', item.id)
        .then(data => {
          this.getData();
          this.item = {};
          this.item.eventId = this.itemEvent.id
          this.item.eventType = this.eventType
          this.item.insertby_id = this.currentUserId; 
        })
    }
    
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
